import { render, staticRenderFns } from "./RegisterReturn.vue?vue&type=template&id=33946a64&scoped=true&"
import script from "./RegisterReturn.vue?vue&type=script&lang=js&"
export * from "./RegisterReturn.vue?vue&type=script&lang=js&"
import style0 from "./RegisterReturn.vue?vue&type=style&index=0&id=33946a64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33946a64",
  null
  
)

export default component.exports